import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { skillAssessmentAnswerOptions } from "../../utils/constant";
import { formRules } from "../../../../../config/validations/formRules";
import { validations } from "../../../../../config/validations/validations";
import { RootState } from "../../../../../store/app";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../utils/hooks/hooks";
import {
  fetchCareersList,
  fetchOccupationalGroups,
  fetchSkillCategory,
} from "../../../../../store/CommonSlice";
import { fetchIndustryList, fetchIndustryWizeData } from "../../../Industry/utils/slice";
import { INDUSTRY_FILTER } from "../../../../../config/Constant";

/**
 * Renders a form component for the SkillPortrait module.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.form - The form instance.
 * @param {string} props.id - The form ID.
 * @param {Function} props.handleSubmit - The form submission handler.
 * @param {Function} props.onValuesChange - The form values change handler.
 * @param {Object} props.editValues - The values for editing the form.
 * @param {...any} props.rest - Additional props.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
  ...rest
}) => {
  const [selectedSkillCategories, setSelectedSkillCategories] = useState<any>(
    []
  );
  const [selectedCareers, setSelectedCareers] = useState<any>([]);
  const [industryList, setIndustryList] = useState<any>([]);


  const [answerOptionValue, setAnswerOptionValue] = useState<number>(
    Number(editValues?.answer_options)
  );
  const userDinterestAssessmentetail: any = useAppSelector(
    (state: RootState) => state.auth.initialData
  );


  const [skillCategory, setSkillCategory] = useState([])
  const [Careers, setCareers] = useState([])
  const [OccupationalGroup, setOccupationalGroup] = useState([])

  const disabledAnswer = { ...rest }.disabled
    ? true
    : editValues?.ans_edit_disable
      ? true
      : false;

  const dispatch = useAppDispatch();




  /**
   * for set values for one dropdown and null for other dropdown 
   * between skill categories and careers.
   */
  const handleSkillCategoriesChange = (value: any) => {
    console.log('change1')
    setSelectedSkillCategories(value);
    setSelectedCareers([]);
  };

  const handleCareersChange = (value: any) => {
    console.log('change2')
    setSelectedCareers(value);
    setSelectedSkillCategories([]);
  };

  // for disable and enable the field for skill categories and careers alternatively: start
  const isSkillCategoriesDisabled = selectedCareers.length > 0;
  const isCareersDisabled = selectedSkillCategories.length > 0;

  useEffect(() => {


    dispatch(fetchIndustryList())
      .then((data: any) => {
        setIndustryList(data.rows);
      })
      .catch((error: any) => error);
    if (editValues) {
      form.setFieldsValue(
        { ...editValues, ...{ industries: editValues?.industries.map((data: any) => data.id) } }
      );

      onIndustryChange(editValues?.industries.map((data: any) => data.id), false);

    }
    const skillcategories: any = [];
    const occupationalGroupValues: any = [];
    const careers: any = [];


    editValues?.skill_assessment_multi.forEach((data: any) => {
      if (data?.type === 1) {
        skillcategories.push(data.parent_id);
        setSelectedSkillCategories([1]);
        setSelectedCareers([]);
      } else if (data?.type === 2) {
        careers.push(data.parent_id);
        setSelectedSkillCategories([]);
        setSelectedCareers([1]);
      } else if (data?.type === 3) {
        occupationalGroupValues.push(data.parent_id);
      }
    });

    if (editValues?.master_type === "0") {
      form.setFieldValue("master_type", null);
    }

    form.setFieldValue("careers", careers);
    form.setFieldValue("skill_categories", skillcategories);
    form.setFieldValue("occupational_group_names", occupationalGroupValues);

    let answersData: any = [];

    if (id == "viewForm") {
      setSelectedCareers([1]);
      setSelectedSkillCategories([1]);
    }

    if (editValues) {
      const answers = editValues?.answer_options;
      if (answers.length > 0) {
        answersData = answers.map((item: any) => {
          return { answer: item.answer };
        });
      }
    } else {
      answersData.push({
        answer: "",
      });
    }
    form.setFieldsValue({
      answers: answersData,
    });
  }, [editValues, form]);

  const onFinish = (data: any) => {
    handleSubmit(data);
  };




  const onIndustryChange = (id: number[], resetVal = true) => {
    if (id.length > 0) {


      dispatch(fetchIndustryWizeData(id, [
        INDUSTRY_FILTER.CAREER_CATEGORY,
        INDUSTRY_FILTER.SKILL_CATEGORY,
        INDUSTRY_FILTER.OCCUPATIONAL_GROUP,
        INDUSTRY_FILTER.CAREER,
      ]))
        .then((response: any) => {

          if (resetVal) {

            var existingSkillCategory = form.getFieldValue('skill_categories');
            var existingOcupationGroup = form.getFieldValue('occupational_group_names');
            var existingCareers = form.getFieldValue('careers');
            const filterdSkill = response.data.skill_category.length > 0 && existingSkillCategory.length > 0 ? existingSkillCategory.filter((item: any) => (response.data.skill_category.find((category: any) => category.id == item) || false)) : []

            const filterdCareer = response.data.career.length > 0 && existingCareers.length > 0 ? existingCareers.filter((item: any) => (response.data.career.find((career: any) => career.id == item) || false)) : []

            form.setFieldsValue({
              skill_categories: filterdSkill,
              occupational_group_names: response.data.occupational_group.length > 0 && existingOcupationGroup.length > 0 ? existingOcupationGroup.filter((item: any) => (response.data.occupational_group.find((group: any) => group.id == item) || false)) : [],
              careers: filterdCareer,
            });
            if (filterdSkill.length > 0) {
              handleSkillCategoriesChange(filterdSkill)
            }

            if (filterdCareer.length > 0) {
              handleCareersChange(filterdCareer)
            }
          }
          setSkillCategory(response.data.skill_category.map((item: any) => {
            item.name = `${item.name} - (${item.code})`
            return item;
          }));
          setCareers(response.data.career.map((item: any) => {
            item.name = `${item.name} - (${item.industries.map((data: any) => data.industry_name).join(', ')})`
            return item;
          }));
          setOccupationalGroup(response.data.occupational_group.map((item: any) => {
            item.name = `${item.name} - (${item.code})`
            return item;
          }));
        })
        .catch((error: any) => error);
    }
    else {
      if (resetVal) {
        form.setFieldsValue({
          skill_categories: [],
          occupational_group_names: [],
          careers: [],
        });
        setSelectedSkillCategories([])
        setSelectedCareers([])
        setSkillCategory([]);
        setOccupationalGroup([]);
        setCareers([]);
      }
    }
  }




  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        {...rest}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              required
              label="Question"
              rules={formRules.custom({ firstLetterUpperCase: true })}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }} >
            <InputBox.Select
              mode="multiple"
              required
              label="Industries"
              name="industries"
              showSearch
              className="multiSelect"
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              onChange={(val) => onIndustryChange(val)}

              options={{
                list: industryList,
                valueKey: "id",
                textKey: "industry_name",
              }}
            />

          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Select
              label="Skill Categories"
              name="skill_categories"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={{
                list: skillCategory,
                valueKey: "id",
                textKey: "name",
              }}
              mode="multiple"
              rules={[
                {
                  validator: async (rule, value) => {
                    if (
                      form.getFieldValue("careers")?.length === 0 &&
                      value.length <= 0
                    ) {
                      return Promise.reject(
                        "Please select either Skill Categories or Career."
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              value={selectedSkillCategories}
              onChange={handleSkillCategoriesChange}
              disabled={isSkillCategoriesDisabled}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Select
              label="Careers"
              name="careers"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={{
                list: Careers,
                valueKey: "id",
                textKey: "name",
              }}
              mode="multiple"
              rules={[
                {
                  validator: (rule, value) => {
                    if (
                      form.getFieldValue("skill_categories")?.length === 0 &&
                      value.length <= 0
                    ) {
                      return Promise.reject(
                        "Please select either Skill Categories or Career."
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              value={selectedCareers}
              onChange={handleCareersChange}
              disabled={isCareersDisabled}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Select
              label="Occupational Groups"
              name="occupational_group_names"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={{
                list: OccupationalGroup,
                valueKey: "id",
                textKey: "name",
              }}
              mode="multiple"
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.TextArea name="description" label="Description" />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Radio
              required
              label="Answer Option"
              name="answer_options"
              options={{
                list: skillAssessmentAnswerOptions,
                valueKey: "id",
                textKey: "name",
              }}
              value={answerOptionValue}
              onChange={(e) => setAnswerOptionValue(parseInt(e.target.value))}
              disabled={disabledAnswer}
            />
          </Col>
          {answerOptionValue === 2 && (
            <Row gutter={15}>
              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                <InputBox.Select
                  label="Master Type"
                  name="master_type"
                  showSearch
                  className="singleSelect"
                  optionFilterProp="children"
                  filterOption={(input, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  options={{
                    list: userDinterestAssessmentetail?.masters,
                    valueKey: "api",
                    textKey: "title",
                  }}
                  rules={[validations.required.select()]}
                />
              </Col>
            </Row>
          )}
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
